// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3046": "b63cef43738d","5878": "51ec6cf8fcad","6863": "454c9f289029","7734": "10f3c2e9ef2b",}[chunkId] + ".css"
}